/**
 * The calendar header's count line with the show-cancelled toggle beside it.
 * Only mounted when there is a cancelled workshop to reveal, or one showing.
 */
import type { ReactNode } from 'react';

import { ShowCancelledToggle } from './ShowCancelledToggle';

export interface WorkshopsCalendarCountLineProps {
  periodCount: ReactNode;
  showCancelled: boolean;
  cancelledCount: number;
  onToggleCancelled: () => void;
}

export function WorkshopsCalendarCountLine({
  periodCount,
  showCancelled,
  cancelledCount,
  onToggleCancelled,
}: WorkshopsCalendarCountLineProps) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      {periodCount}
      <ShowCancelledToggle
        showing={showCancelled}
        count={cancelledCount}
        onToggle={onToggleCancelled}
      />
    </span>
  );
}
